import { FC, useState } from "react";
import ControlledAccord from "./Controlled";
import { UncontrolledCstmAccordProps } from "DataTypes/Common";

const UncontrolledAccord: FC<UncontrolledCstmAccordProps> = (props) => {
  const { head, body, handleClick, accordianOpen, expandOnIconOnly, ...rest } =
    props;
  const [open, setOpen] = useState(false);
  const isOpen = accordianOpen !== undefined ? accordianOpen : open;

  return (
    <ControlledAccord
      head={head}
      body={body}
      open={isOpen}
      expandOnIconOnly={expandOnIconOnly}
      handleClick={() => {
        if (accordianOpen === undefined) {
          setOpen((prev) => !prev);
        }
        handleClick?.();
      }}
      {...rest}
    />
  );
};
export default UncontrolledAccord;
